import { Box } from '@mui/material';
import { LoadingIndicator } from '@puffin/ui-library';
import { RouterProvider } from '@tanstack/react-router';
import { useEffect } from 'react';
import { ApplicationConfigurationGate } from './configuration/ApplicationConfigurationGate';
import { router } from '../services/routing/router';
import { setAnalyticsUser } from '../services/analytics';
import { useAuthenticatedUser } from '../services/auth/AuthenticatedUserContext';

const getFirstName = (name: string) => name.trim().split(/\s+/)[0];

export const AuthenticatedApplication = () => {
  const user = useAuthenticatedUser();

  useEffect(() => {
    if (user) {
      setAnalyticsUser(user.itdId);
    }
  }, [user]);

  if (!user) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
        <LoadingIndicator aria-label="Loading user profile" />
      </Box>
    );
  }

  return (
    <ApplicationConfigurationGate firstName={getFirstName(user.name)}>
      <RouterProvider router={router} />
    </ApplicationConfigurationGate>
  );
};
